import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { Box, TableBody, Typography } from '@mui/material';
import emptyBox from '../asset/boxBlank.png';

// ----------------------------------------------------------------------

export function TableNoData({ colSpan }) {
  return (
    <TableBody>
      <TableRow>
        <TableCell align="center" colSpan={colSpan} sx={{ py: 10 }}>
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <img src={emptyBox} alt="No Trucks" style={{ width: '120px' }} />

            <Typography sx={{ fontSize: 14, fontWeight: 'bold' }} color="#010f58">
              No Data Found!
            </Typography>
          </Box>
        </TableCell>
      </TableRow>
    </TableBody>
  );
}
